import PensionInput from './PensionInput.js';

export default PensionInput;
